export default "__VITE_ASSET__CH0cJE5x__"